import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface EventsPageShellProps {
  children: ReactNode;
  outerClassName?: string;
  maxWidthClassName?: string;
}

export function EventsPageShell({
  children,
  outerClassName,
  maxWidthClassName = 'max-w-5xl',
}: EventsPageShellProps) {
  return (
    <div
      className={cn('w-full mx-auto px-0 md:px-4 py-0 md:py-6', maxWidthClassName, outerClassName)}
    >
      {children}
    </div>
  );
}
